<template>
  <v-container>
    <v-sheet>
      <v-toolbar dense elevation="0">
        <v-toolbar-title class="subtitle-2 text-capitalize">
          Payments
        </v-toolbar-title>
        <v-spacer />
        <v-btn color="primary" small @click="drawer = true">
          <v-icon left small>mdi-plus</v-icon>
          Create Payment Request
        </v-btn>
      </v-toolbar>
      <v-divider />

      <v-tabs v-model="tab" active-class="primary lighten-5" class="mt-4">
        <v-tab>Pending Payments</v-tab>
        <v-tab>Payment History</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <PendingPayments />
        </v-tab-item>

        <v-tab-item>
          <PaymentHistory />
        </v-tab-item>
      </v-tabs-items>
    </v-sheet>

    <!-- Create Request Drawer -->
    <v-navigation-drawer v-model="drawer" fixed right temporary width="400">
      <ServiceRequestDrawer @close="drawer = false" />
    </v-navigation-drawer>
  </v-container>
</template>

<script>
import PendingPayments from "../components/PendingPayments";
import PaymentHistory from "../components/PaymentHistory";
import ServiceRequestDrawer from "../components/ServiceRequestDrawer";
import { AuthService } from "../../auth";

export default {
  name: "Payments",
  components: {
    PendingPayments,
    PaymentHistory,
    ServiceRequestDrawer,
  },
  data: () => ({
    tab: 0,
    drawer: false,
  }),
  mounted() {
    this.$store.dispatch("Payments/getServiceTypes", {
      $filter: `membershipCategory eq '${this.profile.MemberShipType}' and Charge_Type eq 'Generic_x0020_Charge' `,
    });
  },
  computed: {
    profile() {
      return AuthService.user?.profile || {};
    },
  },
};
</script>

<style scoped></style>
